import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { toastError, toastSuccess } from '@components/Toast';

import EODate from '@features/collection/components/EODate';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { clearSampleRequest, fetchSampleProductList } from '@store/actions/SampleAction';

import { findAllUsersByUserTypes } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { _getKey, getTodaysDate, packTag, renderSetImages, setTag } from '@utils/Util';

const CostingAdd = ({ selectedDesignIds, onClose }) => {
	const [selectedDesigns, setSelectedDesigns] = useState([]);
	const sampleStore = useSelector((store) => store.sampleStore);
	const isLoading = useSelector((store) => store.loaderStore);
	const [assigneeList, setAssigneeList] = useState([]);
	const [selectedAssignee, setSelectedAssignee] = useState({});
	const [errors, setErrors] = useState([]);
	const [eoDate, setEoDate] = useState(null);
	const [isEoDateError, setIsEoDateError] = useState(false);
	const [assigneeError, setAssigneeError] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [selectedQty, setSelectedQty] = useState('');

	useEffect(() => {
		setSelectedDesigns(sampleStore.selectedProducts);
	}, [sampleStore]);

	useEffect(() => {
		dispatch(openLoader());
		dispatch(fetchSampleProductList(selectedDesignIds)).finally(() => {
			dispatch(closeLoader());
		});
		(async () => {
			try {
				dispatch(openLoader());
				let params = '?userTypes=COSTING_MANAGER';
				const data = await findAllUsersByUserTypes(params);
				let userList = [];
				for (let item in data) {
					let users = data[item]?.map((item) => ({ value: item.id, label: item.name }));
					userList = [...userList, ...users];
				}
				setAssigneeList(userList);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, []);

	const onUpdateError = (value, id, type) => {
		let allErrors = [...errors];
		if (value) {
			let updated = allErrors.filter((item) => {
				if (parseInt(item.errorDesignId) === parseInt(id) && item.type !== type) {
					return item;
				}
			});
			setErrors(updated);
		}
	};

	const onChangeDate = (value, id) => {
		let updatedDesigns = selectedDesigns;
		updatedDesigns.forEach((item) => {
			if (item.id === id) {
				item['requiredDate'] = value;
			}
			if (!item.requiredDate) {
				item['requiredDate'] = value;
			}
			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
		// let error = errors.filter((err) => err.type !== 'DATE');
		// setErrors(error);
		onUpdateError(value, id, 'DATE');
	};

	const onChangeItem = (e, id) => {
		let { name, value } = e.target;
		let updatedDesigns = selectedDesigns;
		updatedDesigns.forEach((item) => {
			if (item.id === id) {
				item[name] = value;
			}
			setSelectedQty(value);
			onUpdateError(value, item.id, 'QUANTITY');

			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
	};

	const onBlurQuantityField = (id) => {
		let updatedDesigns = selectedDesigns;
		updatedDesigns.forEach((item) => {
			if (!item.quantity && item.id !== id) {
				item['quantity'] = selectedQty;
			}
			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
	};

	const isValidForm = (body) => {
		setErrors([]);
		let isValid = true;
		body.forEach((item) => {
			if (!item.requiredDate) {
				setErrors((old) => [...old, { errorDesignId: item.productId, type: 'DATE' }]);
				isValid = false;
			}
			if (!item.quantity) {
				setErrors((old) => [...old, { errorDesignId: item.productId, type: 'QUANTITY' }]);
				isValid = false;
			}
		});
		return isValid;
	};

	const onGetDateError = (item) => {
		return errors.some((err) => err?.errorDesignId === item.id && err?.type === 'DATE');
	};

	const onGetQuantityError = (item) => {
		return errors.some((err) => err?.errorDesignId === item.id && err?.type === 'QUANTITY');
	};

	const getFomattedData = () => {
		let data = selectedDesigns?.map((item) => {
			return {
				productId: item.id,
				requiredDate: item.requiredDate,
				quantity: item.quantity,
				isSet: !!item.isSet,
				setMemberIds: item?.setMemberProductIds
			};
		});
		return data;
	};

	const onSubmitCosting = async () => {
		let body = getFomattedData();
		const isValid = isValidForm(body);
		let isValidEoDate = true;
		if (!eoDate) {
			setIsEoDateError(true);
			isValidEoDate = false;
		}
		if (!selectedAssignee?.value) {
			setAssigneeError(true);
			isValidEoDate = false;
		}
		if (!isValid || !isValidEoDate) return;
		setErrors([]);
		dispatch(openLoader());
		await ApiClient.POST('requestQuote', {
			quoteItemRequest: body,
			estimatedOrderDeliveryDate: eoDate,
			costingEngineerId: selectedAssignee?.value
		})
			.then(({ data }) => {
				dispatch(closeLoader());
				dispatch(clearSampleRequest());
				navigate(`/costing/${data.id}`);
				toastSuccess(data.message);
				onClose();
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	const isValidQuantity = (e) => {
		const valuesAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ','];
		if (!valuesAllowed.includes(e.key)) {
			e.preventDefault();
		}
	};

	const onCancelPopUp = () => {
		onClose('CANCEL');
	};

	return (
		<Modal show={true} onHide={onCancelPopUp} backdrop="static" className="width-1200-modal">
			<div className="common-popup add-sample-details-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Quote Request</h3>
					</div>

					<div className="close-btn" onClick={onCancelPopUp}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<Modal.Body>
					<div className="common-popup-body scroll-y-label pb-0">
						<div className="sample-details-table">
							<div className="row">
								<div className="col-md-4">
									<div className="form-group no-shadow-react-select">
										<label htmlFor="po-number">Costing Manager*</label>
										<Select
											onChange={(selected) => {
												setSelectedAssignee({
													label: selected.label,
													value: selected.value
												});
											}}
											value={selectedAssignee}
											options={assigneeList}
											className={assigneeError ? 'common-border-error' : ''}
										/>
									</div>
								</div>
								<div className="col-md-4">
									<EODate
										eoDate={eoDate}
										setEoDate={(val) => {
											setIsEoDateError(false);
											setEoDate(val);
										}}
										isEoDateError={isEoDateError}
									/>
								</div>
							</div>
							<table className="table with-border">
								<thead>
									<tr>
										<th className="design-details-column">
											<span className="ml-2">
												{selectedDesignIds.length > 1 ? 'Designs' : 'Design'}
												{`(${selectedDesignIds.length})`}
											</span>
										</th>
										<th className="sample-details-column">Qty</th>
										<th className="date-column">Required date</th>
									</tr>
								</thead>
								<tbody>
									{selectedDesigns.map((item, idx) => (
										<tr key={item.id}>
											<td className="design-details-column ">
												<div className="d-flex align-items-center">
													{item.isSet ? (
														renderSetImages(item?.designDocuments)
													) : (
														<img
															src={item?.designDocuments[0]?.docUrl}
															alt="image"
															className="cell-img pr-2"
														/>
													)}
													{item.isSet ? (
														<div className="ml-12">
															{setTag()}
															<ul className="common-list-component my-1">
																{item?.setMemberProducts?.length > 1 && (
																	<li>
																		{
																			item?.setMemberProducts[0]
																				?.productGroup
																		}
																	</li>
																)}
																{item.setMemberProducts &&
																	item.setMemberProducts.length > 1 &&
																	item?.setMemberProducts.map((member) => (
																		<li key={_getKey()}>
																			{member?.category}
																		</li>
																	))}
															</ul>
															<p className="regular-12 gray_dark_01">
																{item?.referenceNumber}
															</p>
														</div>
													) : (
														<div className="ml-12">
															{item.isPack && packTag()}
															<p className="regular-12 gray_dark_01 py-1">
																{item?.referenceNumber || item?.name}
															</p>
															<ul className="common-list-component mb-2">
																<li>{item?.productGroup}</li>
																<li>{item?.category}</li>
															</ul>
														</div>
													)}
												</div>
											</td>
											<td>
												<input
													className={`${
														onGetQuantityError(item) && 'common-border-error'
													}`}
													type="text"
													autoComplete="off"
													name="quantity"
													autoFocus={idx === 0 && true}
													value={item?.quantity || ''}
													onChange={(e) => {
														onChangeItem(e, item?.id);
													}}
													onBlur={() => onBlurQuantityField(item?.id)}
													onKeyPress={isValidQuantity}
												/>
											</td>

											<td className="date-column">
												<div
													className={`${
														onGetDateError(item) && 'common-border-error'
													}`}
												>
													<input
														id={item.id}
														type="date"
														name="required-date"
														min={getTodaysDate()}
														value={item?.requiredDate}
														onChange={(e) =>
															onChangeDate(e.target.value, item.id)
														}
													/>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCancelPopUp}>
							<span className="gray_dark_02">Cancel</span>
						</button>
						<button
							className="button size32 ml-2"
							onClick={() => {
								onSubmitCosting();
							}}
							disabled={isLoading}
						>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default CostingAdd;
